import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const AlertTriangle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.39043 18.0983L10.6153 3.89171C11.0699 3.10655 11.2972 2.71396 11.5937 2.58211C11.8524 2.4671 12.1476 2.4671 12.4063 2.58211C12.7028 2.71396 12.9301 3.10654 13.3847 3.89171L21.6096 18.0983C22.0658 18.8863 22.2939 19.2803 22.2602 19.6037C22.2308 19.8857 22.083 20.142 21.8536 20.3088C21.5907 20.5 21.1354 20.5 20.2249 20.5H3.77511C2.86459 20.5 2.40933 20.5 2.14637 20.3088C1.91701 20.142 1.76924 19.8857 1.73984 19.6037C1.70612 19.2803 1.93423 18.8863 2.39043 18.0983Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 8.99999V13M12 17H12.01M10.6153 3.89171L2.39043 18.0983C1.93423 18.8863 1.70612 19.2803 1.73984 19.6037C1.76924 19.8857 1.91701 20.142 2.14637 20.3088C2.40933 20.5 2.86459 20.5 3.77511 20.5H20.2249C21.1354 20.5 21.5907 20.5 21.8536 20.3088C22.083 20.142 22.2308 19.8857 22.2602 19.6037C22.2939 19.2803 22.0658 18.8863 21.6096 18.0983L13.3847 3.89171C12.9301 3.10654 12.7028 2.71396 12.4063 2.58211C12.1476 2.4671 11.8524 2.4671 11.5937 2.58211C11.2972 2.71396 11.0699 3.10655 10.6153 3.89171Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Bell01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const AlertCircle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);
